import { useMutation } from '@tanstack/react-query';
import { useToast } from 'components/ui/use-toast';
import * as Api from '../api';
import * as Types from '../types';

const useSaveAnswer = () => {
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (data: Types.IMutation.SaveAnswer) => {
      const response = await Api.SaveAnswer(data.attemptId, {
        questionId: data.questionId,
        value: data.value,
      });
      return response.data;
    },
    // Surface save failures instead of swallowing them: a silently-dropped
    // answer (e.g. a 413 on a large drawing, or a network blip) would otherwise
    // be lost with no recourse for the candidate.
    onError: (error: any) => {
      console.error('Failed to save answer:', error?.response?.data?.message || error.message);
      toast.error('Answer not saved', {
        description:
          'We couldn’t save your last answer. Check your connection and try again before submitting.',
      });
    },
  });
};

export default useSaveAnswer;
